import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/Logo";

export default function Footer() {
  const [content, setContent] = useState(null);
  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="mt-40 border-t border-white/10 bg-[#0a0a0a]">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo size={44} wordClassName="text-xl sm:text-2xl" />
          <p className="mt-4 max-w-md text-sm text-white/50 leading-relaxed">
            {content?.footer_tagline ||
              "Must be 18+. Contains nicotine. Nicotine is an addictive chemical."}
          </p>
          <p className="mt-6 text-xs font-label text-white/30">
            © {new Date().getFullYear()} Vape Essence — Johannesburg, ZA
          </p>
        </div>
        <div>
          <div className="font-label text-xs text-white/40 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-[#00FFC2]">All Products</Link></li>
            <li><Link to="/shop?cat=Disposable Vapes" className="hover:text-[#00FFC2]">Disposable Vapes</Link></li>
            <li><Link to="/shop?cat=Nicotine Pouches" className="hover:text-[#00FFC2]">Nicotine Pouches</Link></li>
            <li><Link to="/about" className="hover:text-[#00FFC2]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#00FFC2]">Contact</Link></li>
            <li><Link to="/track" className="hover:text-[#00FFC2]">Track order</Link></li>
            <li><Link to="/wishlist" className="hover:text-[#00FFC2]">Wishlist</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-label text-xs text-white/40 mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>{content?.contact_email}</li>
            <li>{content?.contact_phone}</li>
            <li>{content?.contact_address}</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
